
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11201",
                "data-name": "矩形 11201",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.067 -0.412)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_241",
        "data-name": "蒙版组 241",
        "class": "cls-2",
        "transform": "translate(0.067 0.412)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "tvroom",
            "transform": "translate(2.933 3.588)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7762",
                "data-name": "路径 7762",
                "class": "cls-3",
                "d": "M404.329,445.754a1.085,1.085,0,0,0-.418.835v3.341a.879.879,0,0,0,.418.731.628.628,0,0,0,.418.1.941.941,0,0,0,.522-.1l2.505-1.67a1.057,1.057,0,0,0,.418-.731.788.788,0,0,0-.418-.731l-2.505-1.67A1.015,1.015,0,0,0,404.329,445.754Zm.626,3.758V446.9l1.983,1.357Z",
                "transform": "translate(-396.878 -438.721)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7763",
                "data-name": "路径 7763",
                "class": "cls-3",
                "d": "M73.764,117.461H68.926l1.238-1.259a.56.56,0,0,0,0-.8.537.537,0,0,0-.788,0l-2.025,2.061H64.426L62.4,115.286a1.222,1.222,0,0,0-.9,0c-.225.115-.113.687,0,.916l1.35,1.259H58.014a1.221,1.221,0,0,0-1.125,1.145v11.449a1.221,1.221,0,0,0,1.125,1.145h15.75a1.221,1.221,0,0,0,1.125-1.145V118.606A1.221,1.221,0,0,0,73.764,117.461Zm0,12.594H58.014V118.606h15.75Z",
                "transform": "translate(-56.889 -115.2)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  